var recipe_b = {
	navChanges: function(){
		jQuery('    <li>\
			<a href="https://www.lulifama-au.com/collections/best-sellers-1"\
			class="site-nav__link site-nav__child-link site-nav__link--last">\
			Best Sellers\
			</a>\
			</li>').insertAfter('.nav-container li:eq(0)');
		jQuery('<li>\
			<a href="/collections/gift-card-collection" class="site-nav__link site-nav__child-link site-nav__link--last">\
			Gift Card\
			</a>\
			</li>').insertAfter('li a.site-nav__link.site-nav__child-link.site-nav__link--last[href="/pages/bundles"]').closest('li');
      jQuery('.site-header.logo--center').addClass('eci-site-header');
		jQuery('li a.site-nav__link.site-nav__child-link.site-nav__link--last[href="/pages/bundles"]').closest('li').insertAfter('li a.site-nav__link.site-nav__child-link.site-nav__link--last[href="/pages/luli-fama-gift-guide"]').closest('li')
		var best_sellers = jQuery('li a[href="https://www.lulifama-au.com/collections/best-sellers-1"]').closest('li');
		var tops = jQuery('li a[href="https://www.lulifama-au.com/collections/best-sellers-1"]').closest('li').next('li');
		jQuery('.dropdown--inner u').each(function(){
			if(jQuery(this).text() == "TOPS"){
				console.log('found');
				jQuery(this).closest('span').wrap('<li class="site-nav--has-dropdown_nojs"></li>')
				jQuery(this).closest('li').insertAfter(best_sellers);
				jQuery(this).unwrap('span');
				jQuery(this).removeAttr('style');
				jQuery(this).wrap('<a href="javascript:void(0)" class="site-nav__link">TOPS</a>');
				jQuery(this).closest('li').find('ul.no-after').wrap('<div class="site-nav__dropdown"><div class="dropdown--inner eci-dropdown--inner"></div></div>');
				jQuery(this).remove();
			}else if(jQuery(this).text() == "BOTTOMS"){
				jQuery(this).closest('span').wrap('<li class="site-nav--has-dropdown_nojs"></li>')
				jQuery(this).closest('li').insertAfter(tops);
				jQuery(this).unwrap('span');
				jQuery(this).removeAttr('style');
				jQuery(this).wrap('<a href="javascript:void(0)" class="site-nav__link">BOTTOMS</a>');
				jQuery(this).closest('li').find('ul.no-after').wrap('<div class="site-nav__dropdown"><div class="dropdown--inner eci-dropdown--inner"></div></div>');
				var sub_menu = jQuery(this).closest('li').find('.no-after');
				var bottoms_menu = jQuery(this).closest('li');
				jQuery('li a.site-nav__link[href="#"]:eq(1)').text('STYLE');
				jQuery('li a.site-nav__link.site-nav__child-link[href="/collections/metallics"]').closest('li').appendTo(sub_menu);
				jQuery('li a.site-nav__link[href="#"]:eq(1)').closest('li').insertAfter(bottoms_menu);
				jQuery(this).remove();
			}
		});
		//just in category changes
		jQuery('a[href="/collections/seamless-bottoms-2"]').closest('span').remove();
		jQuery('a[href="/collections/d-cups"]').closest('span').remove();
      jQuery('a[href="/pages/ciao-bella"]').closest('li').remove();
      
      jQuery('a[href="/pages/absoluli-vibrant"]').closest('li').addClass('eci-hide');
      jQuery('a[href="/pages/greece-campaign"]').closest('li').addClass('eci-hide');
		var style_submenu = jQuery('li a[href="/pages/revel-in-the-sun-prints').closest('span')
		jQuery('li a[href="/collections/two-piece').closest('span').insertBefore(style_submenu);
		jQuery('li a[href="/collections/two-piece').closest('span').find('u').addClass('eci-hide');
		jQuery('a.site-nav__link.site-nav__child-link[href="/collections/swim"]').closest('li').addClass('eci-hide');
		jQuery('a.site-nav__link.site-nav__child-link[href="/collections/best-sellers"]').closest('li').addClass('eci-hide');
		jQuery('a.site-nav__link.site-nav__child-link[href="/collections/exclusive').closest('li').addClass('eci-hide');
		var style_menu = jQuery('li a.site-nav__link[href="#"]:eq(0)').closest('li')
		jQuery(' <li class="site-nav--has-dropdown_nojs" aria-haspopup="true" aria-controls="SiteNavLabel-shop-the-look">\
			<a href="javascript:void(0)"\
			class="site-nav__link site-nav__child-link site-nav__link--last">\
			CLOTHING & ACTIVE\
			</a>\
			</li>').insertAfter(style_menu);
		var cloting_active = jQuery('a.site-nav__link.site-nav__child-link.site-nav__link--last[href="javascript:void(0)"]:eq(0)').closest('li');
		jQuery('<span style="display: inline-block; position: relative; float: left;"><u style="padding-left: 15px;">RESORTWEAR</u></span>').appendTo(cloting_active);
		jQuery('<span style="display: inline-block; position: relative; float: left;"><u style="padding-left: 15px;">ACTIVE</u></span>').appendTo(cloting_active);
		var first_span = jQuery(cloting_active).find('span:eq(0)');
		var second_span = jQuery(cloting_active).find('span:eq(1)');
		jQuery('a.site-nav__link[href="/collections/resortwear"]').closest('li').find('.no-after').appendTo(first_span);
		jQuery('a.site-nav__link[href="/collections/activewear"]').closest('li').find('.no-after').appendTo(second_span);
		jQuery('a.site-nav__link[href="/collections/resortwear"]').closest('li').addClass('eci-hide');
		jQuery('a.site-nav__link[href="/collections/activewear"]').closest('li').addClass('eci-hide');
		jQuery('a.site-nav__link[href="#"]:eq(1)').text('COLLECTIONS');
		var collection_submenu = jQuery('li a.site-nav__link.site-nav__child-link[href="/pages/greece-campaign"]:eq(1)').closest('li');
		jQuery('li a.site-nav__link.site-nav__child-link.site-nav__link--last[href="/pages/lf01-digital-presentation"]').closest('li').insertBefore(collection_submenu);
		var collection_submenu_digital = jQuery('li a.site-nav__link.site-nav__child-link.site-nav__link--last[href="/pages/lf01-digital-presentation"]').closest('li')
		jQuery('li a.site-nav__link.site-nav__child-link.site-nav__link--last[href="/pages/revel-in-the-sun-live"]').closest('li').insertAfter(collection_submenu_digital);
		jQuery('li a.site-nav__link.site-nav__child-link.site-nav__link--last[href="/pages/greece-campaign"]').closest('li').addClass('eci-hide');
		jQuery('li a.site-nav__link.site-nav__child-link.site-nav__link--last[href="/pages/absoluli-vibrant"]').closest('li').insertAfter(collection_submenu);
		jQuery('li a.site-nav__link.site-nav__child-link[href="/pages/fiji"]').closest('li').addClass('eci-hide');
		jQuery('li a.site-nav__link.site-nav__child-link[href="/pages/shop-for-the-occasion"]').closest('li').addClass('eci-hide');
		jQuery('li a.site-nav__link.site-nav__child-link[href="/pages/your-bikini-horoscopes"]').closest('li').addClass('eci-hide');
		var sale = jQuery('li a.site-nav__link[href="/collections/sale"]').closest('li.site-nav--has-dropdown_nojs');
		jQuery(' <li class="site-nav--has-dropdown_nojs" aria-haspopup="true" aria-controls="SiteNavLabel-shop-the-look">\
			<a href="javascript:void(0)"\
			class="site-nav__link site-nav__child-link site-nav__link--last">\
			MORE\
			</a>\
			</li>').insertAfter(sale);
		var more_menu = jQuery('li a.site-nav__link.site-nav__child-link.site-nav__link--last[href="javascript:void(0)"]:eq(1)').closest('li');
		jQuery('<span style="display: inline-block; position: relative; float: left;"><u style="padding-left: 15px;">ACCESSORIES</u></span>').appendTo(more_menu);
		var first_more_span = jQuery(more_menu).find('span');
		jQuery('li a.site-nav__link.site-nav__child-link[href="/collections/accessories"]').closest('ul.no-after').appendTo(first_more_span);
		jQuery('li a.site-nav__link.site-nav__child-link[href="/collections/floral"]').closest('span').insertAfter(first_more_span);
		var second_more_span = jQuery(more_menu).find('span').next('span');
		jQuery('li a.site-nav__link.site-nav__child-link[href="/collections/girls-swim"]').closest('span').insertAfter(second_more_span);
		jQuery('li a.site-nav__link[href="/collections/swim"]').closest('li').addClass('eci-hide');
		jQuery('li a.site-nav__link[href="/collections/resortwear"]:eq(0)').closest('li').addClass('eci-hide');
		jQuery('li a.site-nav__link[href="/collections/activewear"]:eq(0)').closest('li').addClass('eci-hide');
		jQuery('li a.site-nav__link[href="/collections/accessories"]:eq(0)').closest('li').addClass('eci-hide');
		jQuery('a[href="/collections/activewear"]').closest('span').find('.no-after li:eq(0)').removeClass('eci-hide');
		jQuery('li a.site-nav__link[href="/collections/neon"]').closest('li').addClass('eci-hide');
		jQuery('li a.site-nav__link[href="/collections/animal-print-trend"]').closest('li').addClass('eci-hide');
		var metallic_og = jQuery('li a.site-nav__link.site-nav__child-link[href="/collections/metallics"]').closest('li')
		var metallic_clone = jQuery(metallic_og).clone();
		var high_cut = jQuery('li a.site-nav__link.site-nav__child-link[href="/collections/high-cut"]').closest('li');
		jQuery(metallic_clone).insertBefore(high_cut);
		jQuery('li a.site-nav__link.site-nav__child-link.site-nav__link--last[href="/products/gift-card"]').closest('li').addClass('eci-hide');
		//submenu
		jQuery(cloting_active).find('span').wrapAll('<div class="site-nav__dropdown"><div class="dropdown--inner eci-dropdown--inner"></div></div>');
		jQuery(more_menu).find('span').wrapAll('<div class="site-nav__dropdown"><div class="dropdown--inner eci-dropdown--inner"></div></div>');
		jQuery(cloting_active).find('.eci-dropdown--inner').append('<span style="clear: both; display:block"></span>');
		jQuery(more_menu).find('.eci-dropdown--inner').append('<span style="clear: both; display:block"></span>');
                 /* ABT-Blinking-Fix-Show Start */
            $(".nav-container").css({"visibility":"visible"});
            /* ABT-Blinking-Fix-Show End */
	},
	init: function(){
		var obj = this;
		var myCounter = 0;
		var myInterval = setInterval(function () {
			if(jQuery('.site-nav--has-dropdown_nojs').length){
				clearInterval(myInterval);
              console.log('test running......');
				obj.navChanges();
			}else{
				myCounter++;
			}
			if(myCounter > 10){
				clearInterval(myInterval);
			}
		},1000);

	},
}.init();